import React, { Suspense, useCallback, useState } from 'react';
import { Button, DataTable, ErrorBox, Flexbox, Input, Panel, Skeleton, } from '@sonika-se/ui-kit/components';
import { graphql, useMutation, usePreloadedQuery, useQueryLoader, } from 'react-relay/hooks';
import { formatDate, toDate } from '@sonika-se/ui-kit/utils/time';
import { useToasts } from '@sonika-se/ui-kit/hooks';
import ErrorBoundary from '~/shared/components/ErrorBoundary';
const query = graphql `
  query PublicHolidaysApiPanelQuery($year: Int!) {
    admin_getHolidaysFromApi(year: $year) {
      date
      isRedDay
      title
    }
  }
`;
export const PublicHolidaysApiPanel = () => {
    const defaultYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(defaultYear);
    const [queryRef, loadQuery] = useQueryLoader(query);
    const refresh = useCallback(() => {
        loadQuery({ year: selectedYear }, { fetchPolicy: 'network-only' });
    }, [selectedYear, loadQuery]);
    const [importHolidays, importHolidaysLoading] = useMutation(graphql `
      mutation PublicHolidaysApiPanel_importHolidaysMutation($model: ImportPublicHolidaysRequestInput!) {
        admin_importPublicHolidays(model: $model) {
          message
          success
        }
      }
    `);
    const toastr = useToasts();
    const handleImportClick = useCallback(() => {
        if (!confirm('Är du säker på att du vill importera helgdagar?')) {
            return;
        }
        importHolidays({
            onCompleted: (data) => {
                toastr.addToast(data.admin_importPublicHolidays.message);
            },
            variables: {
                model: {
                    year: selectedYear,
                },
            },
        });
    }, [selectedYear]);
    return (<Panel title="Helgdagar via API" actions={<>
          <Flexbox gap="small" justify="end">
            <Input type="number" value={selectedYear} onChange={(e) => {
                setSelectedYear(Number(e));
            }}/>
            <Button 
        //icon={faSync}
        size="small" appearance="filled" onClick={() => {
                // setDisplayDeleteConfirm(true)
                refresh();
            }}>
              Hämta
            </Button>
            <Button 
        //icon={faSync}
        color="danger" size="small" appearance="filled" disabled={importHolidaysLoading} onClick={() => {
                // setDisplayDeleteConfirm(true)
                handleImportClick();
            }}>
              Importera
            </Button>
          </Flexbox>
        </>}>
      <ErrorBoundary onError={() => (<ErrorBox height="100%">
            <Flexbox gap="large" direction="column" align="center">
              <p>Något gick fel</p>
            </Flexbox>
          </ErrorBox>)}>
        {queryRef && (<Suspense fallback={<Skeleton height="100%" type="page"/>}>
            <RenderTable queryRef={queryRef}/>
          </Suspense>)}
        {!queryRef && <div>Välj år och hämta</div>}
      </ErrorBoundary>
    </Panel>);
};
const RenderTable = ({ queryRef }) => {
    const data = usePreloadedQuery(query, queryRef);
    const holidays = data === null || data === void 0 ? void 0 : data.admin_getHolidaysFromApi.map((x, index) => ({
        date: x.date,
        title: x.title,
        isRedDay: x.isRedDay,
    }));
    return (<>
      <DataTable columns={{
            title: {
                text: 'Namn',
            },
            date: {
                render: (date) => formatDate(toDate(date), 'date'),
                text: 'Datum',
            },
            isRedDay: {
                render: (isRedDay) => (isRedDay ? 'Ja' : 'Nej'),
                text: 'Röd dag',
            },
        }} rows={holidays}/>
    </>);
};
export default PublicHolidaysApiPanel;
